export default "__VITE_ASSET__DrlKfJce__"